export default "__VITE_ASSET__b3ee611d__"